import React from "react";

import TextMask from "react-text-mask";

export default class InputPhoneNumber extends React.Component {
  render() {
    const {
      input,
      className,
      disabled,
      meta: { touched, error },
    } = this.props;
    return (
      <div className="position-relative w-100">
        <TextMask
          {...input}
          mask={[
            /[0-9]/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
          ]}
          className={className || 'form-control'}
          type="text"
          placeholder="Nhập số điện thoại"
          disabled={disabled}
          style={{
            borderColor: `${touched && error ? "#FF0000" : "#727E91"}`,
          }}
        />
        {touched && error && (
          <div
            style={{
              color: "#FF0000",
              margin: "0 0 10px",
              fontSize: "0.75rem",
            }}
          >
            {error}
          </div>
        )}
      </div>
    );
  }
}
